import React from "react";
import DynamicTable from "./DynamicTable";

interface Props {
  meta: {
    id: number;
    nom: string;
  };
  rows: Record<string, any>[];
}

const IndicatorView: React.FC<Props> = ({ meta, rows }) => {
  return (
    <div>
      <DynamicTable data={rows} showId={false} showDateImport={false} showStatus={false} showIle={false} showCommune={false} showLocalite={false} showRegion={false}/>
    </div>
  );
};

export default IndicatorView;
